export const MEETING_TYPE_WALKIN_MET = 'Walk-in';
export const MEETING_TYPE_WALKIN_NO_CONTACT = 'No-contact visit';
export const MEETING_TYPE_WALKIN_LEGACY = 'Site visit';

export const WALKIN_MET_LABEL = 'Walk-in · Met contact';
export const WALKIN_NO_CONTACT_LABEL = 'Walk-in · No contact';
export const WALKIN_MET_SHORT = 'Met contact';
export const WALKIN_NO_CONTACT_SHORT = 'No contact';

export const FIELD_VISIT_TYPES = new Set([
  MEETING_TYPE_WALKIN_MET,
  MEETING_TYPE_WALKIN_NO_CONTACT,
  MEETING_TYPE_WALKIN_LEGACY,
]);

export const isNoContactVisit = m =>
  m?.type === MEETING_TYPE_WALKIN_NO_CONTACT || m?.type === MEETING_TYPE_WALKIN_LEGACY;

export const isWalkinMet = m => m?.type === MEETING_TYPE_WALKIN_MET;

export const isFieldVisitMeeting = m => FIELD_VISIT_TYPES.has(m?.type);

export const meetingTypeLabel = type => {
  if (type === MEETING_TYPE_WALKIN_MET) return WALKIN_MET_LABEL;
  if (type === MEETING_TYPE_WALKIN_NO_CONTACT || type === MEETING_TYPE_WALKIN_LEGACY) return WALKIN_NO_CONTACT_LABEL;
  return type || '';
};

export const meetingTypeShortLabel = type => {
  if (type === MEETING_TYPE_WALKIN_MET) return WALKIN_MET_SHORT;
  if (type === MEETING_TYPE_WALKIN_NO_CONTACT || type === MEETING_TYPE_WALKIN_LEGACY) return WALKIN_NO_CONTACT_SHORT;
  return type || '';
};
